/** 
 * Translated from enum com.dataiku.dip.security.ldap.LdapGroupMembershipUserAttribute
 * Via: UIModel annotation in the class hierarchy
 */
export enum LdapGroupMembershipUserAttribute {
    UID = "UID",
    CN = "CN",
    DN = "DN",
}